// Generated from OpenAPI. Do not edit.
export const referenceCollections = {
  companies: "companies",
  sites: "sites",
  "delivery-points": "deliveryPoints",
  "site-areas": "siteAreas",
  tags: "tags",
  "site-tags": "siteTags",
  meters: "meters",
  equipment: "equipment",
  users: "users",
  "measurement-series": "series",
  anomalies: "anomalies",
  recommendations: "recommendations",
  works: "works",
  reports: "reports",
  "audit-events": "audit",
} as const;
export const collectionModels = {
  companies: "Company",
  sites: "Site",
  "delivery-points": "DeliveryPoint",
  "site-areas": "SiteArea",
  tags: "TagDefinition",
  "site-tags": "SiteTagAssignment",
  meters: "Meter",
  equipment: "Equipment",
  users: "User",
  "measurement-series": "DataSeries",
  anomalies: "WorkflowItem",
  recommendations: "WorkflowItem",
  works: "WorkflowItem",
  reports: "WorkflowItem",
  "audit-events": "AuditEvent",
} as const;
